import { c as _c } from "react/compiler-runtime";
import { Box, BoxProps, Heading, HeadingProps, Text, TextProps, VStack } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import React from 'react';
export const GenericBlock = props => {
  const $ = _c(25);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const t0 = props.background || "colorPalette.panel";
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue([12, 12, 14, 14, 20, 24]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== getBreakpointValue) {
    t2 = getBreakpointValue([12, 12, 14, 14, 20, 24]);
    $[2] = getBreakpointValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== getBreakpointValue) {
    t3 = getBreakpointValue([4, 6, 8]);
    $[4] = getBreakpointValue;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== getBreakpointValue || $[7] !== props.children || $[8] !== props.headingProps || $[9] !== props.textProps) {
    t4 = (props.headingProps || props.textProps) && <VStack align="center" gap={getBreakpointValue([2, 2, 4])} marginBottom={props.children && getBreakpointValue([6, 6, 8, 10, 12])} paddingX={getBreakpointValue([4, 6, 8])} textAlign="center" width="full">{props.headingProps && <Heading as="h3" size={getBreakpointValue(["2xl", "3xl", "4xl", "4xl", "5xl"])} textAlign="center" {...props.headingProps} />}{props.textProps && <Text fontSize={getBreakpointValue(["lg", "lg", "xl", "xl", "2xl"])} maxWidth="container.lg" {...props.textProps} />}</VStack>;
    $[6] = getBreakpointValue;
    $[7] = props.children;
    $[8] = props.headingProps;
    $[9] = props.textProps;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== props.childBoxProps || $[12] !== props.children) {
    t5 = <Box width="full" {...props.childBoxProps}>{props.children}</Box>;
    $[11] = props.childBoxProps;
    $[12] = props.children;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== props.innerBoxProps || $[15] !== t4 || $[16] !== t5) {
    t6 = <Box marginX="auto" maxWidth="container.xl" {...props.innerBoxProps}>{t4}{t5}</Box>;
    $[14] = props.innerBoxProps;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== props.boxProps || $[19] !== t0 || $[20] !== t1 || $[21] !== t2 || $[22] !== t3 || $[23] !== t6) {
    t7 = <Box background={t0} gap={0} paddingBottom={t1} paddingTop={t2} paddingX={t3} width="full" {...props.boxProps}>{t6}</Box>;
    $[18] = props.boxProps;
    $[19] = t0;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
};